import api from "../http/api";

const buildHeaders = (institutionId) => ({
  headers: { institutionId },
});

export const getAiInsights = async ({ institutionId }) => {
  if (!institutionId) {
    throw new Error("institutionId obrigatório para buscar AiInsights.");
  }

  try {
    const response = await api.client.get(`api/v1/AiInsights`, buildHeaders(institutionId));
    if (response.status === 204) return null;
    return response.data;
  } catch (error) {
    if (error?.response?.status === 204) return null;
    if (error?.response?.status === 403) {
      throw new Error("Você não tem permissão para acessar os Insights com IA desta instituição.");
    }
    throw new Error(
      error?.response?.data?.error || "Falha ao buscar Insights com IA."
    );
  }
};

export const regenerateAiInsights = async ({ institutionId, startDate, endDate }) => {
  if (!institutionId) {
    throw new Error("institutionId obrigatório para regenerar AiInsights.");
  }

  try {
    const response = await api.client.post(
      `api/v1/AiInsights/regenerate`,
      { startDate: startDate || null, endDate: endDate || null },
      buildHeaders(institutionId)
    );
    return response.data;
  } catch (error) {
    if (error?.response?.status === 429) {
      const retryAfter = error?.response?.data?.retryAfterSeconds ?? 60;
      const err = new Error(
        `Aguarde ${retryAfter}s antes de regenerar. ${error?.response?.data?.error || ""}`.trim()
      );
      err.code = "cooldown";
      err.retryAfterSeconds = retryAfter;
      throw err;
    }
    throw new Error(
      error?.response?.data?.error || "Falha ao enfileirar regeneração de AiInsights."
    );
  }
};

export const recordAiInsightInteraction = async ({
  institutionId,
  snapshotId,
  insightType = null,
  seen = false,
  dismissed = false,
  clicked = false,
}) => {
  if (!institutionId || !snapshotId) return;

  try {
    await api.client.patch(
      `api/v1/AiInsights/interactions`,
      { snapshotId, insightType, seen, dismissed, clicked },
      buildHeaders(institutionId)
    );
  } catch (error) {
    console.warn("Falha ao registrar interação com AiInsight:", error?.message);
  }
};

export const saveAiInsightDisplayOrder = async ({ institutionId, orderedTypes }) => {
  if (!institutionId) {
    throw new Error("institutionId obrigatório para salvar a ordem dos insights.");
  }
  if (!Array.isArray(orderedTypes)) {
    throw new Error("orderedTypes deve ser um array.");
  }

  try {
    await api.client.put(
      `api/v1/AiInsights/display-order`,
      { orderedTypes },
      buildHeaders(institutionId)
    );
  } catch (error) {
    if (error?.response?.status === 403) {
      throw new Error(
        error?.response?.data?.error ||
          "Você não tem permissão para alterar a ordem dos insights nesta instituição."
      );
    }
    throw new Error(
      error?.response?.data?.error || "Falha ao salvar a ordem de prioridade dos insights."
    );
  }
};

export const rateAiInsight = async ({
  institutionId,
  snapshotId,
  insightId,
  insightType = null,
  rating,
}) => {
  if (!institutionId) {
    throw new Error("institutionId obrigatório para avaliar AiInsight.");
  }
  if (!snapshotId || !insightId) {
    throw new Error("snapshotId e insightId obrigatórios.");
  }
  if (!Number.isInteger(rating) || rating < 1 || rating > 5) {
    throw new Error("rating deve ser inteiro entre 1 e 5.");
  }

  try {
    await api.client.patch(
      `api/v1/AiInsights/ratings`,
      { snapshotId, insightId, insightType, rating },
      buildHeaders(institutionId)
    );
  } catch (error) {
    throw new Error(
      error?.response?.data?.error || "Falha ao registrar avaliação do insight."
    );
  }
};
